import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routes, routeFor } from 'src/core/constants/routes';

import { NavLink } from '../NavLink/NavLink';

type Props = {
  company: {
    id: string;
  };
};

export const BookkeepLink = ({ company }: Props) => {
  const { t } = useTranslation('global');

  return (
    <NavLink
      href={routeFor(routes.EXPENSE_INBOX_PREPARE.path, {
        company: company.id,
      })}
      iconName="calculator"
      activePaths={[
        routes.EXPENSE_INBOX_PREPARE.path,
        routes.EXPENSE_INBOX_EXPORT_HISTORY.path,
        routes.EXPENSE_INBOX_EXPORT.path,
        routes.EXPENSE_INBOX_REVIEW_EXPORT.path,
      ]}
    >
      {t('misc.bookkeepTitle')}
    </NavLink>
  );
};
